import styled from 'styled-components';

export const FlagContainer = styled.button`
  color: black;
  cursor: pointer;
  margin: 12px auto;
  border: none;
  background: transparent;
`;

export const FlagIconContainer = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
